export default function ShowNotes({bucket, text}) {
  const maxLines = 4;
  const lineHeight = 1.45; // approximate line height in rem
  const maxHeight = `${maxLines * lineHeight}rem`;

  return (
    <div className="rel-notes">
      <div className="rel-notes-header">
        Release Notes - {bucket}
      </div>
      <div
        className="rel-notes-content"
        tabIndex={0}
        role="region"
        aria-label={`Release notes for ${bucket}`}
        dangerouslySetInnerHTML={{ __html: text }}
        style={{
          maxHeight: maxHeight,
          overflowY: 'auto',
          overflowX: 'auto'
        }}
      />
    </div>
  );
}